import classNames from "classnames/bind";
import React from "react";
import styles from "./ItemSuggestions.module.scss"
import { Link } from "react-router-dom";
import { useLanguageStore } from "../../../stores/Language/useLanguageStore";
import { translateProductName } from "../../../utils/translateProductName";
import { calculateDiscountPercentage } from "../../../utils/priceUtils";
const cx = classNames.bind(styles)

const ItemSuggestions = ({ item }) => {

    const { formatPrice } = useLanguageStore()

    const discountPercentage = calculateDiscountPercentage(item.regular_price, item.sale_price)
    const hasSale = discountPercentage && discountPercentage > 0

    return (
        <Link to={`/product-detail/${item.id}/${item.slug}`} className={cx("item__suggestion")}>
            <div className={cx("item-image")}>
                <img src={item.image} alt={item.name} loading="lazy"/>
            </div>
            <div className={cx("item-info")}>
                <h4 className={cx("title")}>{translateProductName(item.name)}</h4>
                <div className={cx("price-container")}>
                    {hasSale ? (
                        <>
                            <span className={cx("sale-price")}>{formatPrice(item.sale_price)}</span>
                            <span className={cx("regular-price")}>{formatPrice(item.regular_price)}</span>
                            <span className={cx("discount-badge")}>-{discountPercentage}%</span>
                        </>
                    ) : (
                        <span className={cx("price")}>{formatPrice(item.regular_price)}</span>
                    )}
                </div>
            </div>
        </Link>
    )
}


export default ItemSuggestions;
